import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BRAND_NAME, BRAND_SHORT } from '../constants/brand';
import logoFallback from '../assets/koc-logo.svg';
import '../styles/Auth.css';

const Register = () => {
  const [logoSrc, setLogoSrc] = useState(`${process.env.PUBLIC_URL || ''}/koc_logo_r4.png`);

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-brand">
          <div className="brand-content">
            <img
              src={logoSrc}
              alt="Koç İnşaat logo"
              className="brand-logo-image"
              onError={() => setLogoSrc((current) => (current === logoFallback ? current : logoFallback))}
            />
            <h1>{BRAND_SHORT}</h1>
            <p>{BRAND_NAME}</p>
            <div className="brand-features">
              <div className="feature"><span>01</span><span>Public kayıt kapalı durumda</span></div>
              <div className="feature"><span>02</span><span>Hesaplar sadece yönetici tarafından açılır</span></div>
              <div className="feature"><span>03</span><span>İlk girişte kullanıcı şifresini kendi belirler</span></div>
            </div>
          </div>
        </div>

        <div className="auth-form-section">
          <div className="auth-form">
            <div className="form-header">
              <h2>Kayıt Kapalı</h2>
              <p>Güvenlik politikası gereği yeni hesap oluşturma yalnızca yönetici tarafından yapılır.</p>
            </div>
            <div className="alert alert-success">
              <span className="alert-icon">i</span>
              <span>Kullanıcı adı ve geçici şifreyi yöneticinizden talep edin.</span>
            </div>
            <div className="form-footer">
              <p><Link to="/login">Giriş sayfasına dön</Link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
